<template>
    <div class="container-login form-login-meio">
        <div class="p-d-flex p-jc-center"> 
            <div>
                <div class="p-d-flex p-jc-center p-mb-5">
                    <a href="/login">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </a>
                </div>
                <div class="card p-fluid p-shadow-3" style="width: 25rem;">
                    <h5 class="p-text-bold p-pt-4">Login</h5>
                    <div class="p-field p-mt-4">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-user"/>                       
                            <InputText v-model.trim="usuario.email" type="text" placeholder="Email"/>                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="exibirErroEmail">Informe o email</small>  
                    </div>
                    <div class="p-field">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-lock" />
                            <InputText v-model.trim="usuario.senha" type="password" placeholder="Senha" v-on:keyup.enter="login"/>                            
                        </span>          
                        <small id="senha-erro" class="p-invalid" v-if="exibirErroSenha">Informe a senha</small>              
                        <div class="p-grid p-d-flex p-jc-between p-mt-1">
                            <div class="p-col-6 p-text-left">
                                <a href="https://www.ikponto.com.br/#pricing" class="text-help">Não tem uma conta?</a> 
                            </div>
                            <div class="p-col-6 p-text-right">
                                <a href="/esqueci-senha" class="text-help">Esqueceu a senha?</a> 
                            </div>                        
                        </div>                                      
                    </div>   
                    <div class="p-grid p-mt-3 p-mb-4">
                        <div class="p-col-12">
                            <Button label="Login" @click="login"/>
                        </div>
                    </div>	
                    <Message severity="error" v-if="exibirErro">{{ mensagemErro }}</Message>
                </div>
                <div class="p-text-center" style="color:#F9B720">Info Kings</div>
                <div v-if="exibirSpin" class="p-text-center"><i class="pi pi-spin pi-spinner" style="font-size: 2rem; color:#F9B720"></i></div>
            </div>
        </div>
    </div> 
</template>

<script>
import LoginService from '@/service/LoginService';
import { mapActions } from 'vuex';
import http from '@/plugins/axios/axios';
import { CHAVE_USUARIO, CHVAE_TOKEN } from '@/global';

export default {
    loginService: null,
    props: ['_aut','_ref','_sp'],
    data() {
        return {
            exibirSpin: false,
            exibirErroEmail: false,
            exibirErroSenha: false,
            mensagemErro: '',
            exibirErro: false,
            ref: null,
            aut: null,
            refAcesso: null,
            usuario: {
                email: '',
                senha: ''
            }
        }
    },    
    methods: {
        ...mapActions('sessao', ['criarSessao', 'limparSessao']),
        ...mapActions('sessao', ['limparSessao']),
		...mapActions('funcionario', ['limparDadosFuncionario']),
		...mapActions('contorlePonto', ['limparRefMarcacoesFuncionario']),
        login() {
            this.exibirSpin = true;
            this.exibirErro = false;
            this.exibirErroEmail = false;
            this.exibirErroSenha = false;
            if(this.usuario.email == '') {
                this.exibirErroEmail = true;
            }
            if(this.usuario.senha == '') {
                this.exibirErroSenha = true;
            }
            if(this.ref && this.aut && this.refAcesso) {
                this.usuario['referencia'] = this.ref;
                this.usuario['autorizacao'] = this.aut;
                this.usuario['refAcesso'] = this.refAcesso;
            }
            if(!this.exibirErroEmail && !this.exibirErroSenha) {            
                this.loginService.autenticar(this.usuario)
                    .then(resp => {
                        this.usuario = {};     
                        // Header do axios
                        http.defaults.headers.common['Authorization'] = 'Bearer '+resp.data.token.valor;                                      
                        this.criarSessao(resp.data);
                        this.exibirSpin = false;                                             
                        this.$router.push({ path: '/' });                       
                    })
                    .catch(erro => {       
                        this.exibirSpin = false;                 
                        this.exibirErro = true;
                        if(erro.response.status == 400) {
                            this.mensagemErro = erro.response.data.mensagem;
                        } else {
                            this.mensagemErro = erro.response.data.mensagem;
                        }
                    });               
            } else {
                this.exibirSpin = false;
            }           
        },
        async validarToken() {    
            this.validarSuporte();                    
            let token = JSON.parse(sessionStorage.getItem(CHVAE_TOKEN));                      
            if(!token) {                                          
                return   
            }       
            let dadosUsuario = JSON.parse(sessionStorage.getItem(CHAVE_USUARIO));                       
            if(!dadosUsuario) {
                return;
            }       
            let usuario = dadosUsuario.usuario;
            let usuarioValidaToken = {
                id: usuario.id,
                email: usuario.email,
                token: token.valor
            }            
            // Validando o token
            const resp = await this.loginService.validarToken(usuarioValidaToken);              
            // Token válido. Atualizar!
            if(resp.data.tokenValido) {                  
                dadosUsuario.token = resp.data.token;
                // Header do axios
                http.defaults.headers.common['Authorization'] = 'Bearer '+resp.data.token.valor;               
                this.criarSessao(dadosUsuario);                 
                if(dadosUsuario.permissoes.includes(126)) {
                    this.$router.push({ path: '/movimento/controle-ponto' });  
                } else {
                    this.$router.push({ path: '/' }); 
                }                           
            } else {
                sessionStorage.clear();
            }
        },
        validarSuporte() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());  
            this.ref = null;
            this.aut = null;
            this.refAcesso = null;
            try {
                if(params.redirect && params.redirect.includes('_refacesso')) {                   
                    if(params.redirect != '/') {                     
                        let query = params.redirect.split('?')[1];
                        let parametros = query.split('&');
                        parametros.forEach(param => {
                            let valor = param.split('=');
                            if(valor[0] == '_ref') {
                                this.ref = valor[1];
                            } else if(valor[0] == '_aut') {
                                this.aut = valor[1];
                            } else if(valor[0] == '_refacesso') {
                                this.refAcesso = valor[1];
                            }
                        });
                    }                    
                }
            } catch (erro) {
                this.ref = null;
                this.aut = null;
                this.refAcesso = null;
                this.usuario.email = '';
                console.log(erro)
            }            
        }       
    },
    created() {
        this.limparDadosFuncionario();
        this.limparRefMarcacoesFuncionario();      
        this.loginService = new LoginService();
        this.validarToken();
    }
}
</script>

<style scoped>    
    
    html, body {
        height: 100vh !important;
        margin: 0px !important;  
    }

    .container-login {
        height: 100vh !important;
        background-color: #232839 !important;
    }

    .form-login-meio {
        padding-top: 130px;
    }

    .text-help {
        font-size: 0.9rem !important;
    }

</style>